import { FieldRender } from "@/lib/types";
import { Label } from "../ui/label";
import { ToggleGroup, ToggleGroupItem } from "../ui/toggle-group";
import { useMemo } from "react";

export const FieldFlex: FieldRender = ({ field }) => {
  const grow = useMemo(() => {
    return (field.value || "0 0 auto").split(" ")[0];
  }, [field.value]);

  const shrink = useMemo(() => {
    return (field.value || "0 0 auto").split(" ")[1];
  }, [field.value]);

  const handleGrowChange = (value: string) => {
    field.onChange(value + " " + shrink);
  };

  const handleShrinkChange = (value: string) => {
    field.onChange(grow + " " + value);
  };

  return (
    <>
      <div className="flex flex-col gap-2">
        <div className="flex items-center">
          <Label className="flex-grow">Grow</Label>
          <ToggleGroup
            type="single"
            variant="outline"
            onValueChange={handleGrowChange}
            defaultValue={grow}
          >
            <ToggleGroupItem value="0">Min</ToggleGroupItem>
            <ToggleGroupItem value="1">Max</ToggleGroupItem>
          </ToggleGroup>
        </div>
        <div className="flex items-center">
          <Label className="flex-grow">Shrink</Label>
          <ToggleGroup
            type="single"
            variant="outline"
            onValueChange={handleShrinkChange}
            defaultValue={shrink}
          >
            <ToggleGroupItem value="0">Min</ToggleGroupItem>
            <ToggleGroupItem value="1">Max</ToggleGroupItem>
          </ToggleGroup>
        </div>
      </div>
    </>
  );
};
